import type { PuckBlockProps, PuckBackground } from "./types";
import { PAGE_BACKGROUND } from "../constants";

export const PUCK_BACKGROUND: Record<PuckBackground, string> = {
  ...PAGE_BACKGROUND,
  transparent: "transparent",
  cream: "#fffef9",
};
export const PUCK_TABLET_MEDIA = "@media (min-width: 768px)";

/** Three named areas let supporting content move below the image on smaller screens. */
export function featureGeometry(
  props: Omit<PuckBlockProps["Feature"], "media" | "main" | "after">
) {
  return {
    display: "grid",
    minWidth: 0,
    alignItems: "start",
    gridTemplateColumns: "minmax(0, 1fr)",
    gridTemplateAreas:
      props.mobileOrder === "main-first" ? '"main" "media" "after"' : '"media" "main" "after"',
    columnGap: `${props.gap}px`,
    rowGap: `${props.mobileGap}px`,
    [PUCK_TABLET_MEDIA]: {
      gridTemplateAreas:
        props.tabletOrder === "main-first" ? '"main" "media" "after"' : '"media" "main" "after"',
      rowGap: `${props.tabletGap}px`,
    },
    "@media (min-width: 992px)": {
      gridTemplateColumns:
        props.mediaSide === "left"
          ? `minmax(0, min(${props.mediaWidth}px, max(0px, calc(100% - 160px - ${props.gap}px)))) minmax(0, 1fr)`
          : `minmax(0, 1fr) minmax(0, min(${props.mediaWidth}px, max(0px, calc(100% - 160px - ${props.gap}px))))`,
      gridTemplateAreas:
        props.mediaSide === "left" ? '"media main" "media after"' : '"main media" "after media"',
      rowGap: `${props.rowGap ?? props.gap}px`,
    },
  };
}
